import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import SignaturePadControl from "../App/SignaturePadControl";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";
type Props = {
  approvalObjectType: number;
  approvalObjectID: number;
  uploadObjectType: number;
  requiredApprovalUser: any;
  IBBProgramID: number;
  QuarterID: number;
  IBBProgramSectionID: number;
  ApprovalTextType: number;
  triggerApprovalParent: Function;
};

export default function ApprovalsScreen(props: Props) {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  //MM:: Approval related data
  const [approvalDataModal, setApprovalDataModal] = useState(false);
  const [approvalData, setApprovalData] = useState({}) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {}, []);

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: props.uploadObjectType,
    MaxAllowedFiles: 1,
    UploadType: 1,
    FolderName: "IBB-Approval-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  const [selectedApprovalUsers, setSelectedApprovalUsers] = useState([]);
  const [selectedApprovalObjects, setSelectedApprovalObjects] = useState([]);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles() {
    let isOkayToGo = false;

    if (approvalData.IsSignatureRequired == true) {
      if (approvalData.SignatureData && approvalData.SignatureData != "") {
        isOkayToGo = true;
      } else {
        isOkayToGo = false;
      }
    } else if (approvalData.IsSignatureRequired == false) {
      isOkayToGo = true;
    }

    if (isOkayToGo) {
      if (uploadFileList && uploadFileList.length > 0) SaveFiles();
      else IBBApprovalSaveCustom([]);
    } else {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Signature is required",
      });
    }
  }

  function SaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = approvalData.IBBRequiredApprovalUserID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            IBBApprovalSaveCustom(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      //saveConactUsData([]);
    }
  }
  //Dragdrop ends

  function IBBApprovalSaveCustom(uploadedFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovaluserid = approvalData.IBBRequiredApprovalUserID;
    object.ibbdelegatedid = approvalData.IBBDelegateID;
    object.ibbprogramid = props.IBBProgramID;
    object.quarterid = props.QuarterID;
    object.name = props.IBBProgramSectionID;
    object.status = approvalData.Status;
    object.notes = approvalData.Notes;
    object.objecttype = props.approvalObjectType;
    object.objectid = approvalData.ObjectID;
    object.signaturedata = approvalData.SignatureData;
    object.filesdata = uploadedFileList;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBApproval/IBBApprovalSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setApprovalDataModal(false);
          props.triggerApprovalParent();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBApprovalSaveCustomBulkApprovals(uploadedFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovalusers = selectedApprovalUsers;
    object.ibbdelegatedid = approvalData.IBBDelegateID;
    object.ibbprogramid = props.IBBProgramID;
    object.quarterid = props.QuarterID;
    object.name = props.IBBProgramSectionID;
    object.status = approvalData.Status;
    object.notes = approvalData.Notes;
    object.objecttype = props.approvalObjectType;
    object.objectids = selectedApprovalObjects;
    object.signaturedata = approvalData.SignatureData;
    object.filesdata = uploadedFileList;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBApproval/IBBApprovalSaveCustomBulkApprovals",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setApprovalDataModal(false);
          setSelectedApprovalObjects([]);
          setSelectedApprovalUsers([]);
          props.triggerApprovalParent();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBApprovalDeleteRecordCustom(IBBApprovalID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbapprovalid = IBBApprovalID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBApproval/IBBApprovalDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          props.triggerApprovalParent();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const handleSave = (signatureDataUrl: string) => {
    // console.log("Signature data URL received in parent:", signatureDataUrl);
    approvalData.SignatureData = signatureDataUrl;
  };

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBApprovalDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {props.approvalObjectID == 0 && selectedApprovalObjects.length > 0 && (
        <div
          className="flex-container"
          style={{ marginBottom: 0, marginTop: 10 }}
        >
          <span></span>
          <div className="flex-items">
            <a
              className="btn-app-rej"
              onClick={() => {
                setApprovalData((prevState: any) => ({
                  ...prevState,
                  Status: 1,
                }));
                setApprovalDataModal(true);
              }}
            >
              Approve Selected
            </a>
            <a
              className="btn-app-rej"
              onClick={() => {
                setApprovalData((prevState: any) => ({
                  ...prevState,
                  Status: 2,
                }));
                setApprovalDataModal(true);
              }}
            >
              Reject Selected
            </a>
          </div>
        </div>
      )}
      <div
        className="appr-main show-title"
        style={{ padding: 10, paddingTop: 0, width: "100%", marginTop: 10 }}
      >
        <div className="pg-importers appr-grid grid-signoff">
          <div className="exceptions-right">
            {props.requiredApprovalUser &&
              props.requiredApprovalUser.map(
                (itemUser: any, indexUser: any) => (
                  <React.Fragment key={"requiredapprovaluser" + indexUser}>
                    {((itemUser.ObjectID == props.approvalObjectID &&
                      props.approvalObjectID > 0) ||
                      props.approvalObjectID == 0) && (
                      <>
                        {props.approvalObjectID == 0 && itemUser.ShowTitle && (
                          <span className="title-spn">
                            {itemUser.ObjectName}
                          </span>
                        )}
                        <div className="">
                          <div className="req-by">
                            <div className="req-left">
                              <div className="req-title"></div>
                              <span className="req-val">
                                {itemUser.JobRoleTitle != "" && (
                                  <> {itemUser.JobRoleTitle} / </>
                                )}

                                {itemUser.UserName}
                                {itemUser.Status != 0 && (
                                  <>
                                    {itemUser.OnBehalfText != "" && (
                                      <span className="signed-by">
                                        ({itemUser.OnBehalfText})
                                      </span>
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                            {itemUser.Status != 0 && (
                              <div className="req-center">
                                {itemUser.SignatureData &&
                                  itemUser.SignatureData != null && (
                                    <img
                                      src={itemUser.SignatureData}
                                      height={30}
                                    />
                                  )}
                                <span>
                                  {moment(itemUser.ApprovalTime)?.format(
                                    "MMMM DD, YYYY hh:mm"
                                  )}
                                </span>
                              </div>
                            )}
                            <div className="req-right">
                              {itemUser.FileURL && (
                                <a
                                  href={itemUser.FileURL}
                                  target="blank"
                                  title="Click to download attachment"
                                >
                                  1
                                </a>
                              )}
                              {itemUser.Notes && (
                                <a
                                  onClick={() => {
                                    setPopUpMessage(itemUser.Notes);
                                    setPopUpMessageModal(true);
                                  }}
                                  title={itemUser.Notes}
                                >
                                  <img
                                    src="images/message.svg"
                                    width={15}
                                    height={15}
                                  />
                                </a>
                              )}
                              {itemUser.CanTakeAction == 1 && (
                                <>
                                  {/* {props.approvalObjectID == 0 && (
                                    <input
                                      type="checkbox"
                                      onChange={(e) => {
                                        let approvalDataLocal = {} as any;
                                        approvalDataLocal.ObjectID =
                                          itemUser.ObjectID;
                                        approvalDataLocal.IBBRequiredApprovalUserID =
                                          itemUser.IBBRequiredApprovalUserID;
                                        approvalDataLocal.IBBDelegateID =
                                          itemUser.IBBDelegateID;

                                        let selectedApprovalObjectsLocal = [
                                          ...selectedApprovalObjects,
                                        ] as any;
                                        let selectedApprovalUsersLocal = [
                                          ...selectedApprovalUsers,
                                        ] as any;

                                        let index =
                                          selectedApprovalObjectsLocal.indexOf(
                                            approvalDataLocal.ObjectID
                                          );
                                        if (index > -1) {
                                          selectedApprovalObjectsLocal.splice(
                                            index,
                                            1
                                          );
                                          selectedApprovalUsersLocal.splice(
                                            index,
                                            1
                                          );
                                        } else {
                                          selectedApprovalObjectsLocal.push(
                                            itemUser.ObjectID
                                          );
                                          selectedApprovalUsersLocal.push(
                                            itemUser.IBBRequiredApprovalUserID
                                          );
                                        }

                                        setSelectedApprovalObjects(
                                          selectedApprovalObjectsLocal
                                        );
                                        setSelectedApprovalUsers(
                                          selectedApprovalUsersLocal
                                        );
                                        setApprovalData(approvalDataLocal);
                                      }}
                                    ></input>
                                  )} */}
                                  {props.approvalObjectID > 0 && (
                                    <>
                                      <a
                                        style={{
                                          background: "green",
                                        }}
                                        className="req-yes"
                                        title="Approve"
                                        onClick={() => {
                                          let approvalDataLocal = {} as any;
                                          approvalDataLocal.ObjectID =
                                            props.approvalObjectID;
                                          if (
                                            approvalDataLocal.ObjectID == 0 &&
                                            itemUser.ObjectID > 0
                                          )
                                            approvalDataLocal.ObjectID =
                                              itemUser.ObjectID;

                                          approvalDataLocal.IBBRequiredApprovalUserID =
                                            itemUser.IBBRequiredApprovalUserID;
                                          approvalDataLocal.IBBDelegateID =
                                            itemUser.IBBDelegateID;
                                          approvalDataLocal.Status = 1;
                                          approvalDataLocal.IsSignatureRequired =
                                            itemUser.IsSignatureRequired;
                                          setApprovalData(approvalDataLocal);
                                          setApprovalDataModal(true);
                                        }}
                                      >
                                        <img
                                          src="images/tick.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                      <a
                                        style={{
                                          background: "red",
                                        }}
                                        className="req-yes"
                                        title="Reject"
                                        onClick={() => {
                                          let approvalDataLocal = {} as any;
                                          approvalDataLocal.ObjectID =
                                            props.approvalObjectID;
                                          if (
                                            approvalDataLocal.ObjectID == 0 &&
                                            itemUser.ObjectID > 0
                                          )
                                            approvalDataLocal.ObjectID =
                                              itemUser.ObjectID;
                                          approvalDataLocal.IBBRequiredApprovalUserID =
                                            itemUser.IBBRequiredApprovalUserID;
                                          approvalDataLocal.IBBDelegateID =
                                            itemUser.IBBDelegateID;
                                          approvalDataLocal.Status = 2;
                                          approvalDataLocal.IsSignatureRequired =
                                            itemUser.IsSignatureRequired;
                                          setApprovalData(approvalDataLocal);
                                          setApprovalDataModal(true);
                                        }}
                                      >
                                        <img
                                          src="images/cross-w.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </>
                                  )}
                                </>
                              )}

                              {itemUser.Status > 0 && (
                                <>
                                  {itemUser.Status == 1 && (
                                    <span className="req-yes">
                                      {props.ApprovalTextType == 1 && (
                                        <> APPROVED</>
                                      )}
                                      {props.ApprovalTextType == 2 && (
                                        <> PASSED</>
                                      )}
                                    </span>
                                  )}
                                  {itemUser.Status == 2 && (
                                    <span className="req-yes req-no">
                                      {props.ApprovalTextType == 1 && (
                                        <> REJECTED</>
                                      )}
                                      {props.ApprovalTextType == 2 && (
                                        <> FAILED</>
                                      )}
                                    </span>
                                  )}
                                  {itemUser.CanDeleteData == 1 && (
                                    <span>
                                      <a
                                        className="btn-primary btn-grid"
                                        onClick={() => {
                                          globalState.setConfirmationObject({
                                            ShowPopup: true,
                                            Heading: "Confirmation ",
                                            Message:
                                              "Are you sure you want to delete this?",
                                            ID: 1,
                                            SelectedID: itemUser.IBBApprovalID,
                                          });
                                        }}
                                        title="Delete"
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </span>
                                  )}
                                </>
                              )}
                              {itemUser.Status == 0 &&
                                (itemUser.CanTakeAction == 0 ||
                                  (itemUser.CanTakeAction == 1 &&
                                    props.approvalObjectID == 0)) && (
                                  <>
                                    <span className="req-pend">PENDING</span>
                                  </>
                                )}
                            </div>
                          </div>
                        </div>

                        {itemUser.IsStartSection && (
                          <div className="req-hr"></div>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )
              )}
          </div>
        </div>
      </div>

      {approvalDataModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">
                {approvalData.IsSignatureRequired && (
                  <>
                    <span className="buis-head">Signature</span>
                    <SignaturePadControl
                      onSave={handleSave}
                    ></SignaturePadControl>
                  </>
                )}
                <span className="buis-head">Comments</span>
                <textarea
                  value={approvalData.Notes}
                  onChange={(e) => {
                    setApprovalData((prevState: any) => ({
                      ...prevState,
                      Notes: e.target.value,
                    }));
                  }}
                ></textarea>

                {props.approvalObjectID > 0 && (
                  <div className="flex-items supp-doc">
                    <span>Supporting Document:</span>
                    <div className="order-drag">
                      <DragDrop
                        ParentFeatures={dragDropFeatures}
                        DragDropCallback={handleDragDropCallback}
                        TriggerChild={triggerChild}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="help-btns">
                <div>
                  Are you sure you want to{" "}
                  <b>{approvalData.Status == 1 ? "Approve" : "Reject"}</b> it?
                  You will not be able to revert it.
                </div>
                {props.approvalObjectID > 0 && (
                  <a
                    onClick={() => {
                      showPopUpForSaveFiles();
                    }}
                  >
                    Yes
                  </a>
                )}
                {props.approvalObjectID == 0 && (
                  <a
                    onClick={() => {
                      IBBApprovalSaveCustomBulkApprovals([]);
                    }}
                  >
                    Yes
                  </a>
                )}
                <a onClick={() => setApprovalDataModal(false)}>No</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
